import * as yup from 'yup';
const userDataValidation = {
  User: yup.object({
    userType: yup.string().required('User Type is required.'),
    userName: yup.string().required('User Name is required.'),
    userEmail: yup
      .string()
      .email('Invalid email')
      .required('Email is required'),
    userAddress: yup.string().required('Address is required'),
    password: yup.string().required('Password is required'),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref('password')], 'Passwords must match')
      .required('Confirm Password is required'),
  }),
};

export default userDataValidation;
